import { designApi } from '../../infrastructure/api/designApi'
import type { UpdateDesignRequest } from '../../infrastructure/api/designApi'
import { errorMessages } from '../shared/errorMessages'

/**
 * Save Design Use Case
 * Handles saving design changes to the API
 */

export type SaveDesignCommand = {
  designId: string
  design: UpdateDesignRequest
  signal?: AbortSignal
}

export type SaveDesignResult = {
  success: boolean
  error?: string
}

export const createSaveDesignUseCase = () => {
  const execute = async (command: SaveDesignCommand): Promise<SaveDesignResult> => {
    try {
      await designApi.updateDesign(
        command.designId,
        command.design,
        command.signal,
        (attempt, error) => {
          // Log retry attempts or emit retry events
          console.warn(`${errorMessages.retryingSaveAttempt(attempt.toString())}: ${error.message}`)
        },
      )

      // In a real implementation, we might emit a design saved event
      // or update the last saved timestamp in the domain
      return { success: true }
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : errorMessages.unknownError(),
      }
    }
  }

  return {
    execute,
  }
}
